import React from 'react';
import Info from './steps/Info';
import Billing from './steps/Billing';
import Confirm from './steps/Confirm';
import PromoCode from './PromoCode';
import Header from './header';
import numeral from 'numeral';

class Registration extends React.Component {
    constructor(props) {
        super();
        this.state = {
            active: props.active || false,
            data: {},
            step: 0,
            promotion_code: '',
        };

        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.setPromotionCode = this.setPromotionCode.bind(this);
    }

    next(data) {
        const newState = { ...this.state };
        Object.assign(newState.data, data);
        newState.step += 1;

        this.setState(newState);
    }

    previous(cardholder_name) {
        const newState = { ...this.state };
        const step = newState.step - 1;

        const data = {
            ...this.state.data,
        };

        if (cardholder_name) data.cardholder_name = cardholder_name;

        this.setState({ step, data });
    }

    setPromotionCode(code) {
        this.setState({
            promotion_code: code,
        });
    }

    render() {
        const geo_locations = JSON.parse(this.props.geo_locations);
        let steps = [
            <Info
                data={this.state.data}
                next={this.next}
                current_url={this.props.current_url}
                geo_locations={geo_locations}
                key={0}
                monthly_pages={this.props.monthly_pages}
                monthly_search_records={this.props.monthly_search_records}
                product={this.props.product}
            />,
            <Billing data={this.state.data} next={this.next} previous={this.previous} key={1} />,
            <Confirm
                data={this.state.data}
                params={this.props}
                promotion_code={this.state.promotion_code}
                next={this.next}
                previous={this.previous}
                key={2}
            />,
        ];

        return (
            <div className="registration-container">
                <Header />

                <div className="row d-flex justify-content-center align-items-top registration-flow">
                    <PromoCode
                        domains_count={this.props.domains_count}
                        promotion={this.props.promotion}
                        endpoint_url={this.props.endpoint_url}
                        product={this.props.product}
                        product_id={this.props.product_id}
                        discount_price={this.props.discount_price}
                        price={this.props.price}
                        show_plans={this.props.show_plans}
                        setPromotionCode={this.setPromotionCode}
                        additional_pages_payment_amount={this.props.additional_pages_payment_amount}
                        per_page_amount={this.props.per_page_amount}
                        search_per_page_amount={this.props.search_per_page_amount}
                        monthly_pages={this.props.monthly_pages}
                        monthly_search_records={this.props.monthly_search_records}
                        ai_credits={this.props.ai_credits}
                    />
                    <div className="col-lg-6 col-sm-6 col-xs-12 registration-container-right">
                        {steps[this.state.step]}
                        <div className="registration-container-right-bottom">
                            <div className="registration-container-right-bottom-title">
                                Important to know
                            </div>
                            <div className="registration-container-right-bottom-item">
                                <img src="/static/img/important_to_know_1.svg" />
                                <div>
                                    Trials are only available for new domains. If a domain has been
                                    registered with GDdash in the past, your account will be charged
                                    immediately. Some features are only available with paid plans
                                </div>
                            </div>
                            <div className="registration-container-right-bottom-item">
                                <img src="/static/img/important_to_know_2.svg" />
                                <div>
                                    This plan requires you to connect your Google Search Console
                                </div>
                            </div>
                            <div className="registration-container-right-bottom-item">
                                <img src="/static/img/important_to_know_3.svg" />
                                <div>
                                    Your plan include {this.props.monthly_pages} Discover pages and{' '}
                                    {this.props.monthly_search_records} Search records per month.
                                </div>
                            </div>
                            <div className="registration-container-right-bottom-item">
                                <img src="/static/img/important_to_know_4.svg" />
                                <div>
                                    Extra charges apply beyond plan limits;{' '}
                                    {numeral(this.props.per_page_amount).format('$0.00')} per extra
                                    Discover page analyzed, and{' '}
                                    {numeral(this.props.search_per_page_amount).format('$0.0000')}{' '}
                                    per Search record (keyword+URL+Device). Charges are calculated
                                    in{' '}
                                    {numeral(this.props.additional_pages_payment_amount).format(
                                        '$0.00',
                                    )}{' '}
                                    increments based on your traffic.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Registration;
